const MFA_AUTHENTICATION_TYPES={
    NOT_SET:0,
    EMAIL:1,
    TEXTMESSAGE:2,
    APP:3,
}

const MFA_STATES={
    ENABLE:1,
    VERIFY:2
}

export {MFA_AUTHENTICATION_TYPES, MFA_STATES}